export default __webpack_public_path__ + "static/media/bsc.8ec275d4.png";